import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { TestimonialsManager } from "./TestimonialsManager";

export function TestimonialsDialog({ pageId, firm, onClose }) {
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto rounded-none border-2 border-black" data-testid="testimonials-dialog">
        <DialogHeader>
          <DialogTitle className="font-chivo font-black uppercase tracking-tight">Testimonials · {firm}</DialogTitle>
          <DialogDescription>
            Ones you add here go live right away. Ones the buyer adds wait for your approval.
          </DialogDescription>
        </DialogHeader>
        <TestimonialsManager pageId={pageId} admin />
      </DialogContent>
    </Dialog>
  );
}
